import { render, staticRenderFns } from "./RealTimeEnergyPrices.vue?vue&type=template&id=47ea8871&scoped=true"
import script from "./RealTimeEnergyPrices.vue?vue&type=script&lang=js"
export * from "./RealTimeEnergyPrices.vue?vue&type=script&lang=js"
import style0 from "./RealTimeEnergyPrices.vue?vue&type=style&index=0&id=47ea8871&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea8871",
  null
  
)

export default component.exports